<template>
    <div class="captureButtonComponent">
        <div class="captureButtonComponent__left">
            <p class="captureButtonComponent__left__title">{{ title }}</p>
            <p class="captureButtonComponent__left__text">{{ text }}</p>

            <span v-if="withEmoji" class="captureButtonComponent__left__emoji">🏀</span>
        </div>

        <routerLink :to="buttonLink" class="captureButtonComponent__right secondary-button">{{ buttonText }}</routerLink>
    </div>
</template>

<style scoped lang="scss" src="./style.scss">
</style>

<script src="./script.js"></script>
